import React from 'react';
import styles from './Item.module.scss';

type Props = {
  coin: string;
  percent: string;
  count: string;
  color: string;
}

const Item: React.FC<Props> = ({
  coin, percent, count, color,
}) => (
  <div className={styles.item}>
    <div className={styles.coin}>{coin}</div>
    <div className={`g-font-num ${styles.percent}`}>{percent}</div>
    <div className={`g-font-num ${styles.count}`}>{count}</div>
    <div className={styles.split} />
    <div className={styles.dot} style={{ background: color }} />
  </div>
);

export default Item;
